import Logger, { LoggerTopic } from "./logger";

// const baseUrl = "http://localhost:3000"
const baseUrl = "https://chat.everydayastronaut.com"
    
export const LoggerClient = (message: string, level: string, token: string | null | undefined = "") => {
    Logger.LOG(level, `${message}`, undefined, LoggerTopic.DEFAULT)
    fetch(`${baseUrl}/api/log?line=${message}&level=${level}`, {
        headers: {
            "Authorization": token || ""
        },
        method: "POST"
    });
}